import { DRAGGABLE_TYPES, WITH_APP_PAGE_BODY_SIZES_CLASS_NAME } from "Common/componentUtils/constants";
import ProgressOverlay from "Components/progressOverlay";
import classNames from "classnames";
import { DocumentFormat, create } from "devexpress-richedit";
import { DocumentFormatApi } from "devexpress-richedit/lib/model-api/formats/enum";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Droppable } from "react-drag-and-drop";
import { useResizeDetector } from "react-resize-detector";
import ActionPanel from "./actionPanel";
import locale from "./summaryReportDetails.locale";
import buildCustomLoadingPanel from "./utils/buildCustomLoadingPanel";
import buildOnDropCallback from "./utils/buildOnDropCallback";
import buildRichEditOptions from "./utils/buildRichEditOptions";
const droppableTypes = [DRAGGABLE_TYPES.SUMMARY_REPORT_OBJECT];
export default function SummaryReportDetails(props) {
    var _a;
    const divRef = useRef(null);
    const abortControllerRef = useRef();
    const richRef = useRef();
    const [richEditReady, setRichEditReady] = useState(false);
    const { height, width, ref: observableRef } = useResizeDetector();
    const [inProgress, setInProgress] = useState(false);
    const [inProgressCancellable, setInProgressCancellable] = useState(false);
    const progressRef = useRef();
    useEffect(() => () => {
        var _a;
        (_a = richRef.current) === null || _a === void 0 ? void 0 : _a.dispose();
    }, []);
    useEffect(() => {
        if (!divRef.current || !height)
            return;
        if (!richRef.current) {
            const options = buildRichEditOptions(!props.canEdit, width, height);
            richRef.current = create(divRef.current, options);
            richRef.current.loadingPanel.customPanel = buildCustomLoadingPanel(setInProgress);
            setRichEditReady(true);
        }
        else {
            richRef.current.readOnly = !props.canEdit;
            divRef.current.style.setProperty("height", `${height}px`);
            divRef.current.style.setProperty("width", `${width}px`);
        }
    }, [height, width, props.canEdit]);
    useEffect(() => {
        if (!divRef.current || !richEditReady || !props.documentObjects)
            return;
        divRef.current.ondrop = buildOnDropCallback(richRef, props.documentObjects, setInProgressCancellable, progressRef, abortControllerRef);
    }, [richEditReady, props.documentObjects, Boolean(richRef.current)]);
    useEffect(() => {
        props.summaryReportId && props.onInitialized && props.onInitialized(props.summaryReportId);
        return () => {
            props.summaryReportId && props.onDestroyed && props.onDestroyed(props.summaryReportId);
            setRichEditReady(false);
        };
    }, [props.summaryReportId]);
    useEffect(() => {
        if (!richEditReady || !richRef.current)
            return;
        if (!props.data || !props.data.BlobData) {
            richRef.current.newDocument();
            return;
        }
        richRef.current.openDocument(props.data.BlobData, props.data.Name, DocumentFormat.Rtf);
    }, [richEditReady, props.summaryReportId, (_a = props.data) === null || _a === void 0 ? void 0 : _a.BlobData]);
    const handleSave = useCallback(() => {
        if (props.data && richRef.current) {
            richRef.current.exportToBase64(base64 => {
                if (props.data && props.onSave) {
                    props.data && props.onSave && props.onSave({ ...props.data, BlobData: base64 });
                    if (richRef.current)
                        richRef.current.hasUnsavedChanges = false;
                }
            }, DocumentFormatApi.Rtf);
        }
    }, [props.data, props.onSave]);
    const handleCancel = useCallback(() => {
        var _a, _b, _c;
        if ((_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.signal.aborted)
            return;
        (_b = progressRef.current) === null || _b === void 0 ? void 0 : _b.setMessage(locale.STOP_PROCESS);
        (_c = abortControllerRef.current) === null || _c === void 0 ? void 0 : _c.abort();
    }, []);
    return (React.createElement(ProgressOverlay, { show: props.inProgress || inProgress || inProgressCancellable, className: props.className, progressRef: progressRef, onCancel: inProgressCancellable ? handleCancel : undefined, cancelText: locale.STOP },
        React.createElement("div", { className: classNames("grid-rows-auto-1fr", WITH_APP_PAGE_BODY_SIZES_CLASS_NAME) },
            React.createElement(ActionPanel, { className: "bg-white overflow-hidden", onSave: props.canEdit ? handleSave : undefined }),
            React.createElement("div", { className: "stretched-to-fit overflow-hidden position-relative", ref: observableRef }, props.canEdit ? (React.createElement(Droppable, { className: "stretched-to-fit overflow-hidden", types: droppableTypes },
                React.createElement("div", { ref: divRef }))) : (React.createElement("div", { ref: divRef }))))));
}
